<template lang="pug">
  .page
    section
        .text-center
          h1 YOUR ACCOUNT
    section.pt-0
      b-container
        b-nav
          b-nav-item(:to="{name: 'AccountProfile'}") PROFILE
          b-nav-item(:to="{name: 'AccountAddress'}") ADDRESS
          b-nav-item(:to="{name: 'AccountOrders'}") ORDERS
          b-nav-item(:to="{name: 'AccountRentals'}") RENTALS
          b-nav-item#btnLogout(@click="logout") LOGOUT
        hr
      b-container.pt-5
        router-view
</template>

<script>

import { mapActions } from 'vuex';
import standardMix from '@/mixins/standardMix';

export default {
  components: {
  },
  mixins: [standardMix],
  data() {
    return {
    };
  },
  computed: {
  },
  methods: {
    ...mapActions('account', ['updateAccount', 'logout']),
    makeMoment() {
      const today = new Date();
      const hour = today.getHours();
      let phase = '';
      if (hour < 12) phase = 'morning';
      else if (hour < 18) phase = 'afternoon';
      else phase = 'evening';
      return phase;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/views/Account.vue